import { AppConstants, ServerConstants, ServiceConstants } from "constant";
import { ServiceModel } from "models";
import { LoginResponse, UserResponse } from "types";
import { AppUtils, StorageUtils } from "utils";

import { APIKit } from "config/axios/index";
import store from "config/redux/index";
import { start, end, error } from "config/redux/slice";

import { handleServiceError } from "./common";

const {
  STORAGE_ACCESS_TOKEN,
  STORAGE_VALID_TO,
  STORAGE_USER,
} = AppConstants;
const {
  REQUEST_LOGIN_ID,
  REQUEST_RENEW_ID,
  REQUEST_LOGOUT_ID,
  REQUEST_REGISTRATION_VERIFY_CODE,
  REQUEST_REGISTRATION_SET_PASSWORD
} = ServiceConstants;
const {
  API_V1_AUTH_LOGIN,
  API_V1_AUTH_LOGIN_RENEW,
  API_V1_AUTH_LOGOUT,
  API_V1_ME,
  API_V1_USERS
} = ServerConstants;

export async function login(email: string, password: string) {
  const requestId = REQUEST_LOGIN_ID;
  try {
    // login
    store.dispatch(start(requestId));
    const loginResponse = await APIKit.post(API_V1_AUTH_LOGIN, {
      email: `${email}`,
      password: `${password}`,
      type: 'EMPLOYEE'
    });
    const loginData: LoginResponse = loginResponse.data;
    StorageUtils.setObject(STORAGE_ACCESS_TOKEN, loginData.accessToken);
    StorageUtils.setObject(STORAGE_VALID_TO, loginData.validTo);

    // user
    const meResponse = await APIKit.get(`${API_V1_ME}`);
    const meData = meResponse.data;
    StorageUtils.setObject(STORAGE_USER, meData);

    initApp();
    store.dispatch(end(new ServiceModel(requestId)));
  } catch (err: any) {
    store.dispatch(error(new ServiceModel(requestId, err)));
  }
}

export async function renew() {
  const requestId = REQUEST_RENEW_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.post(API_V1_AUTH_LOGIN_RENEW);
    const data: LoginResponse = response.data;
    StorageUtils.setObject(STORAGE_ACCESS_TOKEN, data.accessToken);
    StorageUtils.setObject(STORAGE_VALID_TO, data.validTo);
    initApp();
    store.dispatch(end(new ServiceModel(requestId)));
    return true;
  } catch (err: any) {
    store.dispatch(error(new ServiceModel(requestId, err)));
    return false;
  }
}

export function initApp() {
  const userData: UserResponse = StorageUtils.getObject(STORAGE_USER);
  AppUtils.changeLanguage(userData.language);
}

export async function logout() {
  const requestId = REQUEST_LOGOUT_ID;
  try {
    store.dispatch(start(requestId));
    await APIKit.post(API_V1_AUTH_LOGOUT);
    store.dispatch(end(new ServiceModel(requestId)));
  } catch (err: any) {
    store.dispatch(error(new ServiceModel(requestId, err)));
  }
  AppUtils.logout();
}

export async function registrationVerifyCode(email: string, code: string) {
  const requestId = REQUEST_REGISTRATION_VERIFY_CODE;
  try {
    store.dispatch(start(requestId));
    const body = {
      email: email,
      code: code
    }
    const response = await APIKit.post(`${API_V1_USERS}/registration-verify`, body);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleServiceError(requestId, err);
  }
}

export async function registrationSetPassword(email: string, identification: string, password: string, confirmationPassword: string) {
  const requestId = REQUEST_REGISTRATION_SET_PASSWORD;
  try {
    store.dispatch(start(requestId));
    const body = {
      email: email,
      identification: identification,
      password: password,
      confirmationPassword: confirmationPassword,
      type: 'EMPLOYEE'
    }
    const response = await APIKit.post(`${API_V1_USERS}/registration-password-set`, body);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleServiceError(requestId, err);
  }
}